import React from 'react';
import SectionTitle from '../../components/SectionTitles/SectionTitle.jsx';
// import TeamData from '../../data/team/team.json';
import PropTypes from "prop-types";
import SingleTeam from '../../components/Team/SingleTeam.jsx';

const Team = ({listGuru}) => {
    return (
        <div className="section section-padding bg-primary-blue">
            <div className="container">
                <SectionTitle
                    titleOption="text-center mb-12"
                    title="Guru profesional kami"
                    subTitle=""
                />

                <div className="row row-cols-lg-4 row-cols-sm-2 row-cols-1 mb-n6 ">
                    {listGuru && listGuru.map((single, key) => {
                        return(
                            <div key={key} className="col mb-6" data-aos="fade-up" data-aos-delay="300">
                                <SingleTeam data={single} key={key} />
                            </div>
                        ); 
                    })}
                </div>

                    
            </div>
        </div>
    )
}

Team.propTypes = {
    listGuru: PropTypes.array
};
Team.defaultProps = {
    listGuru: []
};

export default Team;
